import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import { title } from "../config/Config";

// ✅ IMPORTS TOP PE
import product_img1 from '../Assets/Images/product1.jpg';
import product_img2 from '../Assets/Images/product2.jpg';
import product_img3 from '../Assets/Images/product1.jpg';
import product_img4 from '../Assets/Images/product_img1.jpg';
import product_img5 from '../Assets/Images/product_img2.jpg';
import product_img6 from '../Assets/Images/product4.jpg';
import product_img7 from '../Assets/Images/product5.jpg';

const Product_main = () => {

  const [sortType, setSortType] = useState("featured");
  const navigate = useNavigate();

  // ✅ PRODUCTS DATA
  const products = [
    {
      id: 1,
      title: "( Jiwandan )Immunity Booster...",
      subtitle: "{title}",
      originalPrice: "2,499.00",
      salePrice: "1,799.00",
      badge: "Sale",
      img: product_img1,
    },
    {
      id: 2,
      title: "HYDRATING SUNSCREEN...",
      subtitle: "{title}",
      originalPrice: "650.00",
      salePrice: "450.00",
      badge: "Sale",
      img: product_img3,
    },
    {
      id: 3,
      title: "Light N Care Anti Blemish Cream...",
      subtitle: "{title}",
      originalPrice: "399.00",
      salePrice: "299.00",
      badge: "Sale",
      img: product_img4,
    },
    {
      id: 4,
      title: "HAIR CARE OIL...",
      subtitle: "{title}",
      originalPrice: "850.00",
      salePrice: "750.00",
      badge: "Sale",
      img: product_img2,
    },
    {
      id: 5,
      title: "Light N Care Facewash...",
      subtitle: "{title}",
      originalPrice: "399.00",
      salePrice: "299.00",
      badge: "Sale",
      img: product_img5,
    },
    {
      id: 6,
      title: "LIVER AMRIT SYRUP...",
      subtitle: "{title}",
      originalPrice: "350.00",
      salePrice: "299.00",
      badge: "Sale",
      img: product_img6,
    },
    {
      id: 7,
      title: "Rakta Mantra...",
      subtitle: "{title}",
      originalPrice: "350.00",
      salePrice: "299.00",
      badge: "Sale",
      img: product_img7,
    },
  ];

  // ✅ SORT LOGIC COMPONENT KE ANDAR
  const sortedProducts = [...products].sort((a, b) => {
    const priceA = parseFloat(a.salePrice.replace(/,/g, ""));
    const priceB = parseFloat(b.salePrice.replace(/,/g, ""));

    switch (sortType) {
      case "az":
        return a.title.localeCompare(b.title);
      case "za":
        return b.title.localeCompare(a.title);
      case "high":
        return priceB - priceA;
      case "low":
        return priceA - priceB;
      case "best":
        return b.id - a.id;
      default:
        return 0;
    }
  });

  return (
    <div className="allProduct_sec">
      <Container>

        {/* 🔥 SORT BAR */}
        <Row>
          <Col lg={6}></Col>

          <Col lg={6}>
            <div className="sort_box">
              <span>Sort by :</span>

              <select
                value={sortType}
                onChange={(e) => setSortType(e.target.value)}
              >
                <option value="featured">Featured</option>
                <option value="best">Best Selling</option>
                <option value="az">A-Z</option>
                <option value="za">Z-A</option>
                <option value="high">High to Low</option>
                <option value="low">Low to High</option>
              </select>

              <span className="count">7 products</span>
            </div>
          </Col>
        </Row>

        {/* 🔥 PRODUCTS */}
        <Row>
          {sortedProducts.slice(0, 7).map((product) => (
            <Col lg={4} md={6} sm={12} key={product.id} className="mb-4">
              <div className="product_card_new">

                <div className="card_images">
                  <img src={product.img} alt="img" className="img_mains" />
                  <img src={product.img} alt="img" className="img_clones" />
                </div>

                <div className="sale_badges">{product.badge}</div>

                <div className="card_contentss">
                  <h3 className="product_titles">{product.title}</h3>
                  <p className="product_subtitles">{product.subtitle}</p>

                  <div className="price_blocks">
                    <span className="original_prices">
                      Rs. {product.originalPrice}
                    </span>
                    <span className="sale_prices">
                      Rs. {product.salePrice}
                    </span>
                  </div>

                  <button className="add_to_cart_btns" onClick={() => navigate("/card")}>
                    Add to cart
                  </button>
                </div>

              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </div>
  );
};

export default Product_main;